import type { IUiState } from './uiStateContext';

export type UiStateAction =
    | { isModalOpen: boolean; type: 'setIsAskEmploymentForSpecializationsModalOpen' }
    | { isModalOpen: boolean; type: 'setIsFeedbackModalOpen' }
    | { isModalOpen: boolean; type: 'setIsSupportModalOpen' }
    | { isTopBarOpen: boolean; type: 'setIsTopBarOpen' }
    | { bannerHeight: number; type: 'setBannerHeight' };

export function uiStateReducer(state: IUiState, action: UiStateAction) {
    switch (action.type) {
        case 'setIsAskEmploymentForSpecializationsModalOpen': {
            return {
                ...state,
                isAskEmploymentForSpecializationsModalOpen: action.isModalOpen,
            };
        }
        case 'setIsFeedbackModalOpen': {
            return {
                ...state,
                isFeedbackModalOpen: action.isModalOpen,
            };
        }
        case 'setIsSupportModalOpen': {
            return {
                ...state,
                isSupportModalOpen: action.isModalOpen,
            };
        }
        case 'setIsTopBarOpen': {
            return {
                ...state,
                isTopBarOpen: action.isTopBarOpen,
            };
        }
        case 'setBannerHeight': {
            return {
                ...state,
                bannerHeight: action.bannerHeight,
            };
        }

        default:
            return state;
    }
}
